<template>
	<v-dialog v-model="value" width="30%" scrollable @click:outside="$emit('input', false)">
		<v-card>
			<v-card-title class="title primary--text mb-2 secondary">
				<v-icon class="mr-3" color="primary">mdi-delete-circle</v-icon>
        <span v-translate class="mr-1">Delete</span>{{name}}
			</v-card-title>
			<v-card-text>
				<p class="grey--text my-3">
					<span v-if="item == 'points'" v-translate class="mr-1">Are you sure you want to delete all the points?</span>
					<template v-else>
          <span v-translate class="mr-1">Are you sure you want to delete this</span>{{name}}?
					<translate
						v-if="item == 'appointment' || item == 'product' || item == 'substance' || item == 'test' || item == 'manipulation'"
					>All information will be permanently deleted.</translate>
          <translate
						v-else-if="item == 'patient' || item == 'user'"
					>All his information, including appointments, will be permanently deleted.</translate>
          <translate
						v-else-if="item == 'joint'"
					>All information, including tests and manipulations, will be permanently deleted.</translate>
          <translate
						v-else-if="item == 'supplier'"
					>All information, including corresponding products, will be permanently deleted.</translate>
					<translate
						v-else
					>All information will be permanently deleted.</translate>
					</template>
				</p>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary darken-1" text :loading="loading" @click="loading = true; $emit('delete')">
					<translate>Yes</translate>
				</v-btn>
				<v-btn color="primary darken-1" text @click="$emit('input', false)">
					<translate>No</translate>
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	name: "DeleteConfirmationDialog",
	props: ["value", "item"],
  data: () => ({
		loading: false
	}),
  computed: {
    name() {
      if(this.item == 'appointment') return this.$gettext('Appointment');
      else if(this.item == 'patient') return this.$gettext('Patient');
      else if(this.item == 'product') return this.$gettext('Product');
      else if(this.item == 'substance') return this.$gettext('Substance');
      else if(this.item == 'user') return this.$gettext('User');
      else if(this.item == 'joint') return this.$gettext('Joint');
      else if(this.item == 'test') return this.$gettext('Test');
      else if(this.item == 'manipulation') return this.$gettext('Manipulation');
      else if(this.item == 'supplier') return this.$gettext('Supplier');
      else if(this.item == 'substance_types') return this.$gettext('Substance Type');
      else if(this.item == 'plant_parts') return this.$gettext('Plant Part');
      else if(this.item == 'product_storages') return this.$gettext('Storage');
			else if(this.item == 'product_presentations') return this.$gettext('Presentation');
			else if(this.item == 'alert') return this.$gettext('Alert');
			else if(this.item == 'product_processing') return this.$gettext('Processing');
			else if(this.item == 'medicine_interactions') return this.$gettext('Drug Interaction');
			else if(this.item == 'medicine_interaction_categories') return this.$gettext('Drug Interaction Category');
			else if(this.item == 'bibliographic_reference') return this.$gettext('Bibliographic Reference');
			else if(this.item == 'discount_code') return this.$gettext('Discount Code');
			else if(this.item == 'consent') return this.$gettext('Consent');
			else if(this.item == 'treatment') return this.$gettext('Treatment');
			else if(this.item == 'topic') return this.$gettext('Topic');
			else if(this.item == 'establishment') return this.$gettext('Establishment');
			else if(this.item == 'document') return this.$gettext('Document');
			else if(this.item == 'result') return this.$gettext('Result');
			else if(this.item == 'appointment_type') return this.$gettext('Appointment Type');
			else if(this.item == 'appointment_location') return this.$gettext('Office');
      else return "";
    }
	},
	watch: {
		value(v) {
			if(v) this.loading = false;
		}
	}
};
</script>